import '../assets/js/main.js';
import '../assets/css/item-style.css';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import Preloader from "../assets/js/preloader.js";
import { NavLink } from "react-router-dom";

import AnimatePage from './animatepage.js';

const Sale = () => {
    return (
        <div>
            <AnimatePage>
                <section className="sale">
                    <section className="home" style={{ minHeight: "100vh" }}>
                        <section className="drops">
                            <span className="item">
                                <img src="img2/airmax97.png"></img>
                                <div className="name">Nike Air Max 97 <span>Atlantic Blue</span></div>
                                <div className="price">499 <span>PLN</span> | <s style={{ color: "#808080" }}>829 PLN</s></div>
                                <div className="tm pr" style={{ fontSize: "20px", paddingTop: "12px" }}>- 39%</div>
                                <a href="https://www.nike.com/pl/t/buty-air-max-97-HmZnqx" className="link">SKLEP</a>
                                <div className="resell "><i className="fa-solid fa-dollar-sign"></i></div>
                                <div className="women s"><i className="fa-solid fa-venus"></i></div>
                            </span>

                            <span className="item">
                                <img src="https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/edc337d0-3359-4198-8602-208fcde1b69a/buty-meskie-air-max-excee-xCj9x2.png"></img>
                                <div className="name">Nike Air Max Excee<span>Dark</span></div>
                                <div className="price">334 <span>PLN</span> | <s style={{ color: "#808080" }}>549 PLN</s></div>
                                <div className="tm pr" style={{ fontSize: "20px", paddingTop: "12px" }}>- 39%</div>
                                <a href="https://www.nike.com/pl/t/buty-meskie-air-max-excee-xCj9x2/CD4165-003" className="link">SKLEP</a>
                                <div className="resell "><i className="fa-solid fa-dollar-sign"></i></div>
                                <div className="women "><i className="fa-solid fa-venus"></i></div>
                            </span>

                            <span class="item">
                                <img src="https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/a73a7f08-07b0-4595-80a4-ed427dea1b79/buty-meskie-court-royale-2-next-nature-fhkCDt.png"></img>
                                <div class="name">Nike Court Royale 2 Next Nature<span>Black</span></div>
                                <div class="price">234 <span>PLN</span> | <s style={{ color: "#808080" }}>329 PLN</s></div>
                                <div class="tm pr" style={{ fontSize: "20px", paddingTop: "12px" }}>- 28% </div>
                                <a href="https://www.nike.com/pl/t/buty-meskie-court-royale-2-next-nature-fhkCDt/DH3160-001" class="link">SKLEP</a>
                                <div class="resell "><i class="fa-solid fa-dollar-sign"></i></div>
                                <div class="women "><i class="fa-solid fa-venus"></i></div>
                            </span>

                            <span class="item">
                                <img src="https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/bf85158d-b59e-42ec-bec5-39555d23fc33/buty-do-golfa-air-max-90-g-1PQxq2.png"></img>
                                <div class="name">Nike Air Max 90 G<span>Pearl White </span></div>
                                <div class="price">644 <span>PLN</span> | <s style={{ color: "#808080" }}>799 PLN</s></div>
                                <div class="tm pr" style={{ fontSize: "20px", paddingTop: "12px" }}>- 19% </div>
                                <a href="https://www.nike.com/pl/t/buty-do-golfa-air-max-90-g-1PQxq2/DO6492-141" class="link">SKLEP</a>
                                <div class="resell "><i class="fa-solid fa-dollar-sign"></i></div>
                                <div class="women "><i class="fa-solid fa-venus"></i></div>
                            </span>

                            <span class="item">
                                <img src="https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/766567e3-8685-4f9e-8471-33baffaab89c/buty-do-skateboardingu-sb-chron-2-CXx0gC.png"></img>
                                <div class="name">Nike SB Chron 2<span>Gum Light</span></div>
                                <div class="price">199 <span>PLN</span> | <s style={{ color: "#808080" }}>329 PLN</s></div>
                                <div class="tm pr" style={{ fontSize: "20px", paddingTop: "12px" }}>- 39% </div>
                                <a href="https://www.nike.com/pl/t/buty-do-skateboardingu-sb-chron-2-CXx0gC/DM3493-002" class="link">SKLEP</a>
                                <div class="resell "><i class="fa-solid fa-dollar-sign"></i></div>
                                <div class="women "><i class="fa-solid fa-venus"></i></div>
                            </span>

                            <span class="item">
                                <img src="https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/284da5e4-bb4b-4724-9201-e70902b2d0dd/buty-air-max-270-lvsXvS.png"></img>
                                <div class="name">Nike Air Max 270<span>Sesame</span></div>
                                <div class="price">529 <span>PLN</span> | <s style={{ color: "#808080" }}>749 PLN</s></div>
                                <div class="tm pr" style={{ fontSize: "20px", paddingTop: "12px" }}>- 29% </div>
                                <a href="https://www.nike.com/pl/t/buty-air-max-270-lvsXvS/DX8951-001" class="link">SKLEP</a>
                                <div class="resell s"><i class="fa-solid fa-dollar-sign"></i></div>
                                <div class="women s"><i class="fa-solid fa-venus"></i></div>
                            </span>

                            <span class="item">
                                <img src="https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/ba0c7c27-098c-4ccb-8c0f-b388d36fec9f/korki-pilkarskie-miekka-murawe-phantom-gt2-elite-sg-pro-ac-V9VDm0.png"></img>
                                <div class="name">Nike Phantom GT2 Elite SG-Pro AC<span>Smoke Grey</span></div>
                                <div class="price">864 <span>PLN</span> | <s style={{ color: "#808080" }}>1229 PLN</s></div>
                                <div class="tm pr" style={{ fontSize: "20px", paddingTop: "12px" }}>- 29% </div>
                                <a href="https://www.nike.com/pl/t/korki-pilkarskie-miekka-murawe-phantom-gt2-elite-sg-pro-ac-V9VDm0/DC0753-001" class="link">SKLEP</a>
                                <div class="resell "><i class="fa-solid fa-dollar-sign"></i></div>
                                <div class="women "><i class="fa-solid fa-venus"></i></div>
                            </span>

                            <span class="item">
                                <img src="https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/53716222-2341-477c-b508-80909e3b0d67/buty-meskie-waffle-debut-gV9P67.png"></img>
                                <div class="name">Nike Waffle Debut<span>Clear</span></div>
                                <div class="price">199 <span>PLN</span> | <s style={{ color: "#808080" }}>329 PLN</s></div>
                                <div class="tm pr" style={{ fontSize: "20px", paddingTop: "12px" }}>- 39% </div>
                                <a href="https://www.nike.com/pl/t/buty-meskie-waffle-debut-gV9P67/DH9522-001" class="link">SKLEP</a>
                                <div class="resell s"><i class="fa-solid fa-dollar-sign"></i></div>
                                <div class="women "><i class="fa-solid fa-venus"></i></div>
                            </span>
                        </section>
                    </section>
                </section>
            </AnimatePage>
        </div>
    );
}

export default Sale;
